import React, { useEffect, useState } from "react";
import axios from "axios";
import "../styles/ModalRecalls.css";

export default function ModalRecalls({
  nExpediente,
  pacienteId,
  onClose
}) {
  const [recalls, setRecalls] = useState([]);
  const [seleccionado, setSeleccionado] = useState(null);
  const [modoEdicion, setModoEdicion] = useState(false);
  const [nuevo, setNuevo] = useState(false);
  const [actuaciones, setActuaciones] = useState([]);

  const [form, setForm] = useState({
    motivo: "",
    periodo: "",
    actuacionId: "",
    comentario: ""
  });
  const authConfig = {
      headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
      }
  };
  
  const formatearMotivo = (motivo) => {
      return motivo
          ?.toLowerCase()
          .replace(/_/g, " ")
          .replace(/\b\w/g, l => l.toUpperCase());
  };

  useEffect(() => {
    if (!nExpediente) return;

    axios.get(`/api/actuaciones/paciente/${nExpediente}`, authConfig)
      .then(r => setActuaciones(r.data));
  }, [nExpediente]);


  const cargar = () => {
    axios.get(`/api/recalls/paciente/${nExpediente}`, authConfig)
      .then(r => setRecalls(r.data));
  };

  useEffect(() => { cargar(); }, []);

  const resetForm = () => {
    setForm({ motivo: "", periodo: "", actuacionId: "", comentario: "" });
    setSeleccionado(null);
    setModoEdicion(false);
    setNuevo(false);
  };

  const guardar = () => {
    const req = {
      motivo: form.motivo,
      periodo: form.periodo,
      comentario: form.comentario,
      actuacionId: form.actuacionId ? Number(form.actuacionId) : null
    };

    const call = nuevo
      ? axios.post(`/api/recalls/paciente/${nExpediente}`, req, authConfig)
      : axios.put(`/api/recalls/${seleccionado.id}`, req, authConfig);

    call.then(() => {
      cargar();
      resetForm();
    });
  };

  const eliminar = () => {
    if (!seleccionado) return;
    axios.delete(`/api/recalls/${seleccionado.id}`, authConfig)
      .then(() => {
        cargar();
        resetForm();
      });
  };

  return (
    <div className="modal-overlay">
      <div className="modal-recalls">

        <header className="modal-header">
          <h3>Recalls del paciente</h3>
          <button onClick={onClose}>✕</button>
        </header>

        <div className="modal-body">

          {/* LISTADO */}
          <table className="recalls-table">
            <thead>
              <tr>
                <th>Fecha</th>
                <th>Motivo</th>
                <th>Actuación</th>
                <th>Comentario</th>
                <th>Estado</th>
              </tr>
            </thead>
            <tbody>
              {recalls.map(r => (
                <tr
                  key={r.id}
                  className={seleccionado?.id === r.id ? "seleccionado" : ""}
                  onClick={() => setSeleccionado(r)}
                >
                  <td>{new Date(r.fechaRecall).toLocaleDateString("es-ES")}</td>
                  <td>{formatearMotivo(r.motivo)}</td>
                  <td>
                    {actuaciones?.find(a => a.id === r.actuacionId)?.tratamiento || "-"}
                  </td>
                  <td>{r.comentario}</td>
                  <td>
                    <span
                      className={`estado-badge estado-${r.estado.toLowerCase()}`}
                    >
                      {r.estado}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* FORMULARIO */}
          {(nuevo || modoEdicion) && (
            <div className="recall-form">
              <select
                required
                placeholder="Periodo"
                value={form.periodo}
                onChange={e => setForm(f => ({ ...f, periodo: e.target.value }))}
              >
                <option value="" disabled>
                  Periodo
                </option>
                <option value="W1">1 semana</option>
                <option value="W2">2 semanas</option>
                <option value="W3">3 semanas</option>
                <option value="M1">1 mes</option>
                <option value="M2">2 meses</option>
                <option value="M3">3 meses</option>
                <option value="M4">4 meses</option>
                <option value="M5">5 meses</option>
                <option value="M6">6 meses</option>
                <option value="M7">7 meses</option>
                <option value="M8">8 meses</option>
                <option value="M9">9 meses</option>
                <option value="M10">10 meses</option>
                <option value="M11">11 meses</option>
                <option value="A1">1 año</option>
              </select>

              <select
                required
                placeholder="Motivo"
                value={form.motivo}
                onChange={e => setForm(f => ({ ...f, motivo: e.target.value }))}
              >
                <option value="" disabled>
                  Motivo
                </option>
                <option value="LIMPIEZA">Limpieza</option>
                <option value="REVISION_GENERAL">Revisión</option>
                <option value="REVISION_CIRUGIA">Revisión cirugía</option>
                <option value="REVISION_ORTODONCIA">Revisión ortodoncia</option>
                <option value="REVISION_IMPLANTES">Revisión implantes</option>
                <option value="SEGUIMIENTO_TRATAMIENTO">Seguimiento</option>
              </select>

              <select
                required
                placeholder="Actuación"
                value={form.actuacionId}
                onChange={e => setForm(f => ({ ...f, actuacionId: e.target.value }))}
              >
                <option value="" disabled>
                  Actuación
                </option>
                {actuaciones.map(a => (
                  <option key={a.id} value={a.id}>
                    {a.tratamiento} – {a.dia}
                  </option>
                ))}
              </select>

              <textarea
                placeholder="Comentario"
                value={form.comentario}
                onChange={e => setForm(f => ({ ...f, comentario: e.target.value }))}
              />
            </div>
          )}
        </div>

        <footer className="modal-footer">
          {!nuevo && !modoEdicion && (
            <>
              <button onClick={() => setNuevo(true)}>➕ Nuevo</button>
              <button disabled={!seleccionado} onClick={() => {
                setModoEdicion(true);
                setForm(seleccionado);
              }}>
                ✏️ Editar
              </button>
              <button className="eliminar" disabled={!seleccionado} onClick={eliminar}>🗑️ Eliminar</button>
            </>
          )}

          {(nuevo || modoEdicion) && (
            <>
              <button onClick={guardar}>Guardar</button>
              <button onClick={resetForm}>Cancelar</button>
            </>
          )}
        </footer>

      </div>
    </div>
  );
}
